import { render, staticRenderFns } from "./NoUseProforms.vue?vue&type=template&id=528dde02&"
import script from "./NoUseProforms.vue?vue&type=script&lang=js&"
export * from "./NoUseProforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports